import { statMoneymapApi, shopZoneLoadApi, ResponseCode, type MoneymapItem } from "@src/api";
import type { StatMoneymapRequest } from "@src/api";
import type { ShopZoneExtended } from "@src/store";

export type ZoneListStoreLike = {
  map: Record<string, ShopZoneExtended>;
  add: (shop_zones: ShopZoneExtended[]) => void;
};

/**
 * Собирает id зон из moneymap data, которых ещё нет в store.
 */
export function getMissingZoneIds(data: MoneymapItem[], zoneMap: Record<string, unknown>): string[] {
  return data.reduce<string[]>((acc, cur) => {
    if (cur.is_zone && !zoneMap[cur.zone_id]) {
      acc.push(cur.zone_id);
    }

    return acc;
  }, []);
}

/**
 * Подгружает недостающие зоны по списку id и добавляет их в store.
 */
export async function ensureZonesLoaded(data: MoneymapItem[], store: ZoneListStoreLike): Promise<void> {
  const ids = getMissingZoneIds(data, store.map);

  if (ids.length === 0) return;

  const load_result = await shopZoneLoadApi({ zone_id: ids });

  if (load_result.code === ResponseCode.OK && load_result.shop_zones?.length) {
    store.add(load_result.shop_zones);
  }
}

/**
 * Запрашивает stat moneymap, подгружает недостающие зоны в store, возвращает data или null.
 */
export async function fetchMoneymapWithZones(
  params: StatMoneymapRequest,
  store: ZoneListStoreLike,
): Promise<MoneymapItem[] | null> {
  const result = await statMoneymapApi(params);

  if (result.code !== ResponseCode.OK) return null;
  if (result.data.length === 0) return [];

  await ensureZonesLoaded(result.data, store);

  return result.data;
}
